import { withDependencies } from '@wix/thunderbolt-ioc'
import type { IViewerManagerPlatformApplicationRequestsAPI, Callback } from './types'

export const ViewerManagerPlatformApplicationRequestsAPI = withDependencies(
	[],
	(): IViewerManagerPlatformApplicationRequestsAPI => {
		const callbacks: Array<Callback> = []
		return {
			registerCallback: (cb) => {
				callbacks.push(cb)
			},
			triggerCallbacks: (appDefinitionId, eventData) => {
				callbacks.forEach((cb) => cb(appDefinitionId, eventData))
			},
		}
	}
)
